export interface GraphNode {
  id: string;
  name: string;
  type: string;
  service: string;
  language: string;
  metadata: {
    path: string;
    team: string;
    tier: string;
    [key: string]: unknown;
  };
}

export interface GraphEdge {
  source: string;
  target: string;
  type: string;
  protocol: string;
  metadata: {
    discoveredBy: string;
    [key: string]: unknown;
  };
}

export interface DependencyGraph {
  metadata: {
    generatedAt: string;
    analyzer: string;
    sources: string[];
  };
  statistics: {
    totalNodes: number;
    totalEdges: number;
    nodesByService: Record<string, number>;
    nodesByLanguage: Record<string, number>;
    edgesByType: Record<string, number>;
    crossServiceEdges: number;
  };
  nodes: GraphNode[];
  edges: GraphEdge[];
  cycles: {
    path: string[];
    length: number;
  }[];
}

// Force graph node format
export interface ForceNode {
  id: string;
  name: string;
  service: string;
  language: string;
  type: string;
  val?: number; // Node size
  color?: string;
  // Cluster properties (only present on cluster nodes)
  _isCluster?: boolean;
  _childCount?: number;
  _clusterKey?: string; // e.g. "Mobile NILAssist/composables"
}

// Force graph link format
export interface ForceLink {
  source: string;
  target: string;
  type: string;
  color?: string;
  width?: number;
}

export interface ForceGraphData {
  nodes: ForceNode[];
  links: ForceLink[];
}

export type ViewMode = '2d' | '3d';

// ── SINGLE SOURCE OF TRUTH: visual sizing & colors ──

export const GRAPH_CONFIG = {
  // Node sizes (react-force-graph nodeRelSize * sqrt/cbrt of val)
  nodeRelSize: 1.5,
  nodeValFile: 10,
  nodeValCluster: (childCount: number) => Math.max(10, childCount * 3),

  // Service colors
  serviceColors: {
    'Mobile NILAssist': '#42b983',
    'PC Support Hub': '#dc3545',
    'Backend (Node/TS)': '#3178c6',
    'LlamaIndex (Python)': '#ff9500',
    'Semantic Kernel (C#)': '#9b4f96',
    'Native iOS (Swift)': '#FFD60A',
  } as Record<string, string>,

  // Edge colors
  edgeColors: {
    'import': '#999999',
    'using': '#9b4f96',
    'http-call': '#ff4136',
  } as Record<string, string>,

  // Edge widths
  edgeWidthDefault: 1,
  edgeWidthHttp: 3,
  edgeWidthCluster: 2,
} as const;
